import { ImtSearch, type ImtSearchParams } from '../objects/ImtSearch'
import { ImtSearchModal, type ImtSearchModalProperties } from '../objects/ImtSearchModal'
import { SignUpPrompt, SignUpPromptType, type SignUpButton } from '../objects/SignUpPrompt'
import { MidMarketModal } from '../objects/MidMarketModal'
import { View, Submit, Click, SignUp, Open, Close } from '../actions'
import { analytics } from './lib'

export const SearchSubmit = (params: ImtSearchParams) =>
  analytics(new Submit(), new ImtSearch(params))

export const SearchView = (params: ImtSearchParams) => analytics(new View(), new ImtSearch(params))

export const SearchClose = (params: ImtSearchParams) =>
  analytics(new Close(), new ImtSearch(params))

export const SearchModalOpen = (properties: ImtSearchModalProperties) =>
  analytics(new Open(), new ImtSearchModal(properties))

export const SignUpPromptView = (type: SignUpPromptType) =>
  analytics(new View(), new SignUpPrompt({ signUpPrompt: { type } }))

export const SignUpPromptClick = (
  type: SignUpPromptType,
  button: SignUpButton,
  title?: string,
  topic?: string,
  pageMetaContext?: {
    countryFrom: string | null
    countryTo: string | null
    payout: string | null
    provider: string | null
  } | null,
) =>
  analytics(
    new Click(),
    new SignUpPrompt({ signUpPrompt: { type, button, title, topic }, pageMetaContext }),
  )

export const SignUpPromptSignUp = (type: SignUpPromptType) =>
  analytics(new SignUp(), new SignUpPrompt({ signUpPrompt: { type } }))

export const MidMarketModalOpen = () => analytics(new Open(), new MidMarketModal())
